import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  template: `
  <h2 *ngIf="data.title" mat-dialog-title>{{data.title}}</h2>
  <div mat-dialog-content>{{data.message}}</div>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">いいえ</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>はい</button>
  </div>
  `,
})
export class ConfirmDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title: string, message: string}
  ) { }
}
